var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4.21608369e-06 0.0112101602 3.97326174 0.0112101602 3.97326174 6.68070074 4.21608369e-06 6.68070074"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.--Overige-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WER-Tool",
    transform: "translate(-1262.000000, -840.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(1262.000000, 840.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(8.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 3.121032)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.281916779,6.6804399 C0.0819167785,6.6804399 0.0819167785,6.67990757 0.0816483221,6.48640679 C0.0813798658,6.21678329 0.0822120805,6.22742983 0.344198658,6.20640292 C0.710373154,6.17712495 0.948225503,5.96978368 0.961916779,5.58224981 C0.989836242,4.79893099 0.986346309,4.01454752 0.993863087,3.23069638 C0.996816107,2.93791667 1.0005745,2.64513695 0.992520805,2.3526234 C0.985809396,2.10509146 0.962695302,1.85835801 0.811849664,1.64462882 C0.636816107,1.39736305 0.373997315,1.31165844 0.0939973154,1.256536 C0.0722255034,1.25230401 0.0502389262,1.2501747 0.0285208054,1.24618225 C0.0247355705,1.24538376 0.021514094,1.24112515 0.00191677852,1.22568767 C0.00191677852,1.1157622 -0.0045261745,0.992262389 0.00623892617,0.870359563 C0.00916510067,0.837621467 0.0604402685,0.793172184 0.0977825503,0.782525648 C0.349567785,0.710901084 0.603795973,0.648113144 0.856681879,0.58077381 C1.52972886,0.401113531 2.20245369,0.220654762 2.87520537,0.0409944832 C2.90956779,0.031678765 2.94554094,0.0279524777 2.9796349,0.0181044328 C3.04782282,-0.00159165699 3.08325906,0.0202337398 3.08350067,0.0923640147 C3.08350067,0.136813298 3.08435973,0.180996419 3.08435973,0.225445703 C3.0848698,1.96801732 3.08379597,3.71085511 3.08892349,5.4536929 C3.0891651,5.5830483 3.11120537,5.72142664 3.16111141,5.83989595 C3.26956779,6.09780827 3.50124564,6.19069928 3.76433289,6.2071748 C3.97155436,6.22048297 3.97453423,6.21279084 3.97155436,6.40762244 C3.96701745,6.7014668 4.02852081,6.67990757 3.69023893,6.68017373 C2.55415839,6.68097222 1.41802416,6.68070606 0.281916779,6.6804399 Z",
    id: "Fill-1",
    fill: "#FAAA28",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.91278926,1.26427604 C2.91278926,1.96250242 2.34186309,2.52855207 1.63762148,2.52855207 C0.933379866,2.52855207 0.362453691,1.96250242 0.362453691,1.26427604 C0.362453691,0.566049652 0.933379866,0 1.63762148,0 C2.34186309,0 2.91278926,0.566049652 2.91278926,1.26427604",
    id: "Fill-4",
    fill: "#FAAA28"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconOrange);
export default __webpack_public_path__ + "static/media/info-icon-orange.05026377788ee7e4462921362f4bad38.svg";
export { ForwardRef as ReactComponent };